import React from 'react';

export const DropdownField = ({
  required = false,
  label = '',
  id = '',
  options = [],
  size = 'full',
  value,
  onChange,
  onBlur,
  error,
  labelStyle='',
  className='',
  labelTitle = '',
  disable=false
}) => {
  return (
    <div className={`w-full md:w-${size}`}>
    <label
        htmlFor={id}
        className={`block mb-0 capitalize text-[14px] font-semibold ${labelStyle}`}
        title={labelTitle}  // Add title attribute here
      >
        {label}{required && "*"}
      </label>
      <select
        id={id}
        name={id}
        className={`bg-white border border-gray-300 text-base text-[14px] rounded-lg block w-full p-2.5 focus:outline-none focus:border-gray-300 text-black ${error ? 'border-red-500' : ''} ${className}`}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        disabled={disable}
      >
        <option value="" selected disabled>Select Your Option</option>
        {options.map((option, index) => (
          <option
            key={index}
            value={option.value}
            disabled={option?.disabled}
            style={{
              backgroundColor: value === option.value ? 'gray' : 'white',
              color: value === option.value ? 'black' : 'inherit'
            }}
          >
            {option.label}
          </option>
        ))}
      </select>
      {error && <div className="text-red-500 text-xs mt-1">{error}</div>}
    </div>
  );
}